import { mapGetters } from 'vuex';
import AuthMixin from '@/mixins/Auth.vue';
import RailMixin from '@/mixins/Rail.vue';

export default {
    name: "CardLiveTournament",
    props: {
        tournament: {
            type: Object,
            required: true
        }
    },

    mixins: [
        AuthMixin,
        RailMixin,
    ],

    computed: {
        ...mapGetters({
            countries: 'countries/countries',
            selectedTournament: 'liveTournaments/selectedTournament',
        }),
    },

    data() {
        return this.initialState();
    },
      
    methods: {
        initialState() {
            return {}
        },
        
        goToTournamentDetails(tournament) {
            let eventId = this.tournament.event.id || this.$route.params.id;
            this.$store.commit('liveTournaments/setSelectedTournament', tournament);
            this.$router.push(`/live/events/${eventId}/tournaments/${tournament.id}`);
        },

        editTournament(tournament) {
            this.$emit('edit-tournament', tournament);
        },

        deleteTournament(tournament) {
            // Lógica para apagar evento
            this.$emit('delete-tournament', tournament);
        },

        getCodeFromCountry(name) {
            let output = 'unknown.svg';

            if (!this._.isEmpty(this.countries) && name) {
                let countryObject = this.countries.find(e => e.name == name);
                if (countryObject) {
                    output = countryObject.code + '.svg'
                }
            }

            return output;
        }
    }
}